<template>
  <div class="couponList">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>营销</el-breadcrumb-item>
      <el-breadcrumb-item>优惠券列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search-container">
      <el-form :inline="true" :model="customerGroupForm" class="demo-form-inline">
        <el-form-item label="优惠券状态">
          <el-select v-model="customerGroupForm.search_status" placeholder="请选择">
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优惠券类型">
          <el-select v-model="customerGroupForm.search_type" placeholder="请选择">
            <el-option label="现金券" :value="1"></el-option>
            <el-option label="折扣券" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="customerGroupForm.dataTime"
            type="daterange"
            align="right"
            unlink-panels
            @change="getTimes"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy/MM/dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="关键字" class="keyword">
          <el-input placeholder="请输入店铺名称" v-model="customerGroupForm.search_keyword"> </el-input>
        </el-form-item>
      </el-form>
      <div class="btn mg-t-10">
        <el-button type="primary" size="medium" @click="getCouponList">查询</el-button>
        <el-button size="medium" @click="clear">清空</el-button>
      </div>
    </div>
    <CouponImport ref="importRef" @success="getCouponList" />
    <div class="dataTable">
      <div class="text-right mg-b-20">
        <el-button type="primary" @click="$router.push('/addCoupon')">添加优惠券</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData.data" border tooltip-effect="dark" style="width: 100%">
        <el-table-column label="优惠券名称" :align="'center'" prop="name" show-overflow-tooltip> </el-table-column>

        <el-table-column prop="status" label="优惠券状态" :align="'center'">
          <template slot-scope="scope">
            <span style="color: #2ed477" v-if="scope.row.status == 1">启用</span>
            <span v-else>停用</span>
          </template>
        </el-table-column>

        <el-table-column prop="desc" label="优惠券内容" :align="'center'" show-overflow-tooltip> </el-table-column>

        <el-table-column label="已使用/已领取/数量" :align="'center'">
          <template slot-scope="scope">
            <span>{{ scope.row.used_num }}/{{ scope.row.getted_num }}/{{ scope.row.usable }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="label" label="适用范围" :align="'center'" show-overflow-tooltip>
          <template slot-scope="scope" v-if="scope.row.goods.length > 0">
            <span v-for="(item, index) in scope.row.goods" :key="index">{{ index + 1 }}. {{ item.name }} </span>
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" :align="'center'"> </el-table-column>
        <el-table-column label="操作" :align="'center'" fixed="right" width="150px">
          <template slot-scope="scope">
            <el-button type="text" @click="mobileCoupon(scope.row)">定向发放</el-button>
            <!-- <el-button type="text" @click="pushCoupon(scope.row)">推送</el-button> -->
            <el-button type="text" @click="$router.push(`/addCoupon?uuid=${scope.row.uuid}`)">编辑</el-button>
            <el-button type="text" @click="$router.push('/couponData?uuid=' + scope.row.uuid)">数据</el-button>
            <el-button type="text" @click="$router.push('/transferRecord?uuid=' + scope.row.uuid)">转赠</el-button>
            <el-button type="text" v-if="scope.row.release_type == 10" @click="genShareQrcode(scope.row)">分享码</el-button>
            <el-button type="text" v-if="scope.row.status == 2" @click="changeStatus(scope.row)">启用</el-button>
            <el-button type="text" v-else @click="changeStatus(scope.row)">停用</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="tableData.total"
        :per_page="tableData.per_page"
        :current_page="tableData.current_page"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
      <!-- 分享发放-种子分享码 -->
      <el-dialog title="分享发放二维码" :visible.sync="shareQrcode.visible" width="360px" center append-to-body>
        <div v-loading="shareQrcode.loading" style="text-align: center; min-height: 260px">
          <img v-if="shareQrcode.img" :src="shareQrcode.img" style="width: 260px; height: 260px" />
          <p style="color: #666; font-size: 13px; margin-top: 10px">{{ shareQrcode.name }}</p>
          <p style="color: #999; font-size: 12px">发给客户/客服扫码即可领取（多人可领，分享人自己的券不受影响）</p>
        </div>
        <span slot="footer">
          <el-button @click="shareQrcode.visible = false">关闭</el-button>
          <el-button type="primary" :disabled="!shareQrcode.img" @click="downloadShareQrcode">下载二维码</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
  import pagination from "../../../components/pagination.vue";
  import CouponImport from "./couponImport/index.vue";
  export default {
    name: "couponList",
    components: {
      pagination,
      CouponImport,
    },
    data() {
      return {
        customerGroupForm: {
          search_keyword: "",
          search_start_time: "",
          search_end_time: "",
          search_status: "",
          search_type: "",
        },
        props: { multiple: true },
        labelOptions: [
          {
            label: "启用",
            value: "ok",
          },
          {
            label: "禁用",
            value: "no",
          },
        ],
        pickerOptions: {
          shortcuts: [
            {
              text: "今天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                console.log(start.getTime());
                start.setTime(
                  start.getTime() -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "昨天",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    3600 * 1000 * 24 * 1 -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    3600 * 1000 * 24 * 7 -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(
                  start.getTime() -
                    3600 * 1000 * 24 * 30 -
                    start.getHours() * 60 * 60 * 1000 -
                    start.getMinutes() * 60 * 1000 -
                    start.getSeconds() * 1000 -
                    start.getMilliseconds()
                );
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        tableData: {
          data: [],
          per_page: 10,
          current_page: 1,
          total: 0,
        },
        // 分享发放-种子分享码弹窗
        shareQrcode: { visible: false, loading: false, img: "", name: "" },
      };
    },
    created() {
      this.getCouponList();
    },
    methods: {
      mobileCoupon(row) {
        this.$refs.importRef.open(row.uuid);
      },
      // 分享发放-生成种子分享码(纯小程序二维码)
      genShareQrcode(row) {
        this.shareQrcode = { visible: true, loading: true, img: "", name: row.name };
        this.axios({
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          data: { coupon_uuid: row.uuid },
          url: ` https://time.api.boyalife.cn/v1/cms/CouponShareQrcode`,
        })
          .then((res) => {
            this.shareQrcode.img = res.data.result.qrcode;
            this.shareQrcode.loading = false;
          })
          .catch((err) => {
            this.shareQrcode.loading = false;
            this.shareQrcode.visible = false;
            this.$message.error(
              (err.response && err.response.data && err.response.data.error && err.response.data.error.message) ||
                "生成失败"
            );
          });
      },
      downloadShareQrcode() {
        if (!this.shareQrcode.img) return;
        const a = document.createElement("a");
        a.href = this.shareQrcode.img;
        a.download = `${this.shareQrcode.name || "coupon"}-分享码.png`;
        a.click();
      },
      pushCoupon(row) {
        this.$confirm("确定推送优惠券?", "推送提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.axios({
            method: "get", //请求方法
            headers: {
              "Content-Type": "application/json",
              "X-Access-Token": this.storage.get("__token"),
              Authorization: `Bearer ${this.storage.get("__token")}`,
            },

            url: ` https://time.api.boyalife.cn/v1/cms/Coupon/push/${row.uuid}`,
          })
            .then((res) => {
              this.$message.success("操作成功！");
              this.getCouponList();
            })
            .catch((err) => {
              this.$message.error(err.response.data.error.message);
            });
        });
      },
      clear() {
        for (let i in this.customerGroupForm) {
          this.customerGroupForm[i] = "";
        }
        this.getCouponList();
      },

      addClass(index) {
        this.currentClass = index;
      },
      // 选择时间
      getTimes(v) {
        this.customerGroupForm.search_start_time = v[0] + " 00:00:00";
        this.customerGroupForm.search_end_time = v[1] + " 23:59:59";
      },
      changeStatus(row) {
        let status = "";
        if (row.status == 1) {
          status = 2;
        } else {
          status = 1;
        }
        this.axios({
          method: "put", //请求方法
          headers: {
            "Content-Type": "application/json",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          data: {
            status,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Coupon/status/${row.uuid}`,
        })
          .then((res) => {
            this.$message.success("操作成功！");
            this.getCouponList();
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      getCouponList() {
        this.axios({
          method: "get", //请求方法
          headers: {
            "Content-Type": "text/html;charset=UTF-8",
            "X-Access-Token": this.storage.get("__token"),
            Authorization: `Bearer ${this.storage.get("__token")}`,
          },
          url: ` https://time.api.boyalife.cn/v1/cms/Coupon?page_index=${this.tableData.current_page}&page_size=${this.tableData.per_page}&search_keyword=${this.customerGroupForm.search_keyword}&search_status=${this.customerGroupForm.search_status}&search_type=${this.customerGroupForm.search_type}&search_start_time=${this.customerGroupForm.search_start_time}&search_end_time=${this.customerGroupForm.search_end_time}&release_type=`,
        })
          .then((res) => {
            this.tableData = res.data.result;
          })
          .catch((err) => {
            this.$message.error(err.response.data.error.message);
          });
      },
      handleSizeChange(v) {
        this.tableData.per_page = v;
        this.getCouponList();
      },
      handleCurrentChange(v) {
        this.tableData.current_page = v;
        this.getCouponList();
      },
      deleteSupplier() {
        this.$confirm("确定删除该供应商吗?", "删除提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$message({
              type: "success",
              message: "成功删除!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      },
    },
  };
</script>
<style scoped>
  .customerGroupList {
    background: #f2f2f2;
  }
  .search-container {
    padding: 20px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    font-size: 12px !important;
  }
  >>> .el-input-group {
    width: 400px;
  }
  .ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    height: 50px;
    max-height: 50px;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
  }
  .couponList .el-table .product .el-image {
    width: 60px;
    height: auto;
    border-radius: 0 !important;
  }
  .dataTable {
    position: relative;
  }
  >>> .el-button--text {
    padding: 5px 0px;
  }
  >>> .el-button--text span {
    font-size: 12px;
  }
  >>> .el-dialog__body {
    padding: 20px;
  }
</style>
